import Head from "next/head";
import { useMemo } from "react";
import type { PropsWithChildren } from "react";
import cn from "classnames";

import CMSLogic from "@/src/logic/CMSLogic";
import { StrapiComponentType } from "@/src/type";
import { UUIDHelper } from "@/src/util";

interface StyledContainerProps {
  id: number | string;
  stylePrefix: string;
  container?: Array<StrapiComponentType.Style.ContainerBreakpoint>;
  className?: string;
  layout?: "main" | "alternate" | "split" | "none";
}

function StyledContainer({ container, className, stylePrefix, id, children, layout }: PropsWithChildren<StyledContainerProps>) {
  const name = useMemo(() => `${stylePrefix ?? "StyledContainer"}_${id ?? UUIDHelper.createUUID(true)}`, [stylePrefix, id]);
  const style = CMSLogic.generateContainerBreakpointStyle(name, container, layout);

  if (!style && !className) {
    return <>{children}</>;
  }

  return (
    <>
      {style && (
        <Head>
          <style
            id={`${name}`}
            dangerouslySetInnerHTML={{ __html: style }}
            type="text/css"
          />
        </Head>
      )}
      <div className={cn(className, name)}>{children}</div>
    </>
  );
}

export default StyledContainer;
